module.exports = __webpack_public_path__ + "static/media/homepage_curriculum.5074da3c.svg";